<template>
  <div class="hotels-grid">
    <HotelCard v-for="(hotel, idx) in hotels" :key="idx" :hotel="hotel" />
  </div>
</template>

<script>
import HotelCard from './HotelCard.vue'

export default {
  name: 'HotelsGrid',
  components: {
    HotelCard
  },
  props: {
    hotels: Array
  }
}
</script>

<style scoped lang="scss">
.hotels-grid {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 10px;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 20px;
    grid-row-gap: 20px;
  }
}
</style>
